module.exports = __webpack_public_path__ + "img/showcase-facebook-fr-ca.423945d7.jpg";